module.exports = __webpack_public_path__ + "img/hr-H-B-4-unload-standup-shadow.37adf38b.png";